import BaseSpinner from "./BaseSpinner.vue";

export default BaseSpinner;
